export const INITIAL_STATE = {
  user: null,
  plan: 'free',
  xp: 0,
  level: 1,
  streak: 0,
  balance: 0,
  income: 0,
  expenses: 0,
  dailyBudget: 0,
  dailySpent: 0,
  payDay: null, // Lønnsdag (1-31)
  lastResetDate: null, // Dato for siste daglig nullstilling
  darkMode: false,
  theme: 'sapphire',
  referralCode: '',
  referralCount: 0,
  ambassador: false,
  language: (() => { try { return localStorage.getItem('savely_lang') || 'en'; } catch(e) { return 'en'; } })(),
  currency: 'NOK',
  goals: [],
  transactions: [],
  achievements: [
    // Free (1-5)
    { id:1,  unlocked:false, xp:50   },
    { id:2,  unlocked:false, xp:100  },
    { id:3,  unlocked:false, xp:100  },
    { id:4,  unlocked:false, xp:75   },
    { id:5,  unlocked:false, xp:50   },
    // Advanced (6-15)
    { id:6,  unlocked:false, xp:200  },
    { id:7,  unlocked:false, xp:200  },
    { id:8,  unlocked:false, xp:200  },
    { id:9,  unlocked:false, xp:300  },
    { id:10, unlocked:false, xp:100  },
    { id:11, unlocked:false, xp:500  },
    { id:12, unlocked:false, xp:500  },
    { id:13, unlocked:false, xp:150  },
    { id:14, unlocked:false, xp:100  },
    { id:15, unlocked:false, xp:150  },
    // Premium (16-30)
    { id:16, unlocked:false, xp:1000 },
    { id:17, unlocked:false, xp:2000 },
    { id:18, unlocked:false, xp:500  },
    { id:19, unlocked:false, xp:200  },
    { id:20, unlocked:false, xp:1000 },
    { id:21, unlocked:false, xp:1000 },
    { id:22, unlocked:false, xp:5000 },
    { id:23, unlocked:false, xp:500  },
    { id:24, unlocked:false, xp:500  },
    { id:25, unlocked:false, xp:5000 },
    { id:26, unlocked:false, xp:300  },
    { id:27, unlocked:false, xp:2000 },
    { id:28, unlocked:false, xp:1000 },
    { id:29, unlocked:false, xp:500  },
    { id:30, unlocked:false, xp:9999 },
  ],  chatHistory: [],
  subscriptions: [],
  weeklyInsight: {
    topCat: '',
    topAmount: 0,
    savingTip: 'Legg inn dine første utgifter for å få personlige tips!',
  },
};

export const XP_PER_LEVEL = 500;
export const LEVEL_NAMES = (lang) => ['',
  lang==='en'?'Beginner':lang==='sv'?'Nybörjare':lang==='da'?'Begynder':'Nybegynner',
  lang==='en'?'Saver':lang==='sv'?'Sparare':lang==='da'?'Opsparer':'Spareforsøk',
  lang==='en'?'On track':lang==='sv'?'På rätt spår':lang==='da'?'På vej':'På vei',
  lang==='en'?'Save Friend':lang==='sv'?'Sparvän':lang==='da'?'Spareven':'Sparevenn',
  lang==='en'?'Save Pro':lang==='sv'?'Sparse Pro':lang==='da'?'Spare Pro':'Spareproff',
  lang==='en'?'Budget Guru':lang==='sv'?'Budget Guru':lang==='da'?'Budget Guru':'Budsjett-guru',
  lang==='en'?'Master Saver':lang==='sv'?'Mästarsparare':lang==='da'?'Mestersparer':'Mestersparer',
  lang==='en'?'Money Wisdom':lang==='sv'?'Pengavisdom':lang==='da'?'Pengevisdom':'Pengevisdom',
  lang==='en'?'Economy Ninja':lang==='sv'?'Ekonomi Ninja':lang==='da'?'Økonomi Ninja':'Økonomi-ninja',
  lang==='en'?'Finance Master':lang==='sv'?'Finansmästare':lang==='da'?'Finansmester':'Finansmester',
];

export const CAT_META = {
  // Norwegian
  Mat:           { icon:'🛒', bg:'#E8FBF3', color:'#0D7045' },
  Transport:     { icon:'🚌', bg:'#EEF2FF', color:'#4338CA' },
  Underholdning: { icon:'🎬', bg:'#FFF7ED', color:'#C2410C' },
  Klær:          { icon:'👕', bg:'#FDF2F8', color:'#9D174D' },
  Helse:         { icon:'💊', bg:'#F0FDF4', color:'#15803D' },
  Sparing:       { icon:'🪙', bg:'#F5F3FF', color:'#7C3AED' },
  Abonnement:    { icon:'📱', bg:'#F5F3FF', color:'#6D28D9' },
  Inntekt:       { icon:'💰', bg:'#FEFCE8', color:'#854D0E' },
  Annet:         { icon:'📦', bg:'#F8FAFC', color:'#475569' },
  // English
  Food:          { icon:'🛒', bg:'#E8FBF3', color:'#0D7045' },
  Shopping:      { icon:'🛍️', bg:'#FDF2F8', color:'#9D174D' },
  Entertainment: { icon:'🎬', bg:'#FFF7ED', color:'#C2410C' },
  Clothing:      { icon:'👕', bg:'#FDF2F8', color:'#9D174D' },
  Health:        { icon:'💊', bg:'#F0FDF4', color:'#15803D' },
  Savings:       { icon:'🪙', bg:'#F5F3FF', color:'#7C3AED' },
  Subscription:  { icon:'📱', bg:'#F5F3FF', color:'#6D28D9' },
  Income:        { icon:'💰', bg:'#FEFCE8', color:'#854D0E' },
  Other:         { icon:'📦', bg:'#F8FAFC', color:'#475569' },
  'Café & food': { icon:'☕', bg:'#FEF3C7', color:'#92400E' },
  // Swedish
  Mat_sv:        { icon:'🛒', bg:'#E8FBF3', color:'#0D7045' },
  Kläder:        { icon:'👕', bg:'#FDF2F8', color:'#9D174D' },
  Sparande:      { icon:'🪙', bg:'#F5F3FF', color:'#7C3AED' },
  Annat:         { icon:'📦', bg:'#F8FAFC', color:'#475569' },
  // Danish
  Tøj:           { icon:'👕', bg:'#FDF2F8', color:'#9D174D' },
  Opsparing:     { icon:'🪙', bg:'#F5F3FF', color:'#7C3AED' },
  Andet:         { icon:'📦', bg:'#F8FAFC', color:'#475569' },
  // Fallback
  Default:       { icon:'📦', bg:'#F8FAFC', color:'#475569' },
};

export const TIPS = [
  'Prøv 24-timers-regelen: vent et døgn før kjøp over 500 kr 💡',
  'Sett opp automatisk overføring til sparekonto rett etter lønning 🏦',
  'Kanseller abonnementer du ikke har brukt på 30 dager 📱',
  'Ta med matpakke 3 dager denne uka og spar ~300 kr 🥪',
  'Bruk kontanter i en uke — du bruker 20% mindre 💵',
  'BSU gir deg 5 000 kr i skattefradrag per år — har du det? 📊',
];

export const PLAN_LIMITS = {
  free:     { maxGoals:3, hasAnalysis:false, hasSubscriptions:false, hasImpulse:false, hasChat:false, hasWeeklyReport:false, hasPrediction:false, hasLock:false },
  advanced: { maxGoals:999, hasAnalysis:true, hasSubscriptions:false, hasImpulse:true, hasChat:true, hasWeeklyReport:true, hasPrediction:false, hasLock:false },
  premium:  { maxGoals:999, hasAnalysis:true, hasSubscriptions:true, hasImpulse:true, hasChat:true, hasWeeklyReport:true, hasPrediction:true, hasLock:true },
};

export const RANKS = [
  { min: 0,    en: 'Beginner',      no: 'Nybegynner',   sv: 'Nybörjare',     da: 'Nybegynder',    emoji: '🌱', color: '#78C85A' },
  { min: 100,  en: 'Saver',         no: 'Sparer',        sv: 'Sparare',       da: 'Opsparer',      emoji: '💰', color: '#4A9EDB' },
  { min: 300,  en: 'Disciplined',   no: 'Disiplinert',   sv: 'Disciplinerad', da: 'Disciplineret', emoji: '🎯', color: '#9B59B6' },
  { min: 600,  en: 'Consistent',    no: 'Konsistent',    sv: 'Konsekvent',    da: 'Konsekvent',    emoji: '🔥', color: '#E67E22' },
  { min: 1000, en: 'Smart Saver',   no: 'Smart Sparer',  sv: 'Smart Sparare', da: 'Smart Opsparer', emoji: '🧠', color: '#27AE60' },
  { min: 2000, en: 'Investor',      no: 'Investor',      sv: 'Investerare',   da: 'Investor',      emoji: '📈', color: '#2980B9' },
  { min: 3500, en: 'Money Master',  no: 'Pengemester',   sv: 'Pengamästare',  da: 'Pengemester',   emoji: '👑', color: '#F39C12' },
  { min: 5000, en: 'Finance Ninja', no: 'Økonomininja',  sv: 'Ekonomininja',  da: 'Økonomininja',  emoji: '🥷', color: '#E74C3C' },
];

export const getRank = (xp) => {
  const sorted = [...RANKS].sort((a, b) => b.min - a.min);
  return sorted.find(r => xp >= r.min) || RANKS[0];
};

export const MILESTONES = [100, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000];

export const DAILY_CHALLENGES = [
  { id: 'save_10',      en: 'Save 10 kr today',              no: 'Spar 10 kr i dag',               sv: 'Spara 10 kr idag',                da: 'Spar 10 kr i dag',               xp: 15, type: 'save',   target: 10 },
  { id: 'save_20',      en: 'Save 20 kr today',              no: 'Spar 20 kr i dag',               sv: 'Spara 20 kr idag',                da: 'Spar 20 kr i dag',               xp: 25, type: 'save',   target: 20 },
  { id: 'save_50',      en: 'Save 50 kr today',              no: 'Spar 50 kr i dag',               sv: 'Spara 50 kr idag',                da: 'Spar 50 kr i dag',               xp: 50, type: 'save',   target: 50 },
  { id: 'save_100',     en: 'Save 100 kr today',             no: 'Spar 100 kr i dag',              sv: 'Spara 100 kr idag',               da: 'Spar 100 kr i dag',              xp: 80, type: 'save',   target: 100 },
  { id: 'log_expense',  en: 'Log an expense today',          no: 'Logg en utgift i dag',           sv: 'Logga en utgift idag',            da: 'Log en udgift i dag',            xp: 20, type: 'log',    target: 1 },
  { id: 'under_budget', en: 'Stay under daily budget',       no: 'Hold deg under daglig budsjett', sv: 'Håll dig under daglig budget',    da: 'Hold dig under dagligt budget',  xp: 30, type: 'budget', target: 0 },
  { id: 'streak',       en: 'Save something to keep streak', no: 'Spar noe for å holde streaken',  sv: 'Spara något för att hålla streak', da: 'Spar noget for at holde streak', xp: 40, type: 'streak', target: 1 },
];
